import React from 'react';
import styles from './MethodToggle.module.css';

// Design agent: Spec 008 — an option may optionally carry a keyboard-shortcut hint. When present,
// `shortcutHint` renders as a small discreet label next to the button text, `shortcutTooltip`
// becomes the button's native title (hover) text, and `ariaKeyshortcuts` is exposed to assistive
// technology via the standard `aria-keyshortcuts` attribute. Options without these fields (for
// instance the Showcase page's demo toggle, which is not tied to any real shortcut) render exactly
// as before, so this stays fully backward compatible with every existing MethodToggle usage.
const MethodToggle = ({ options, selectedValue, onChange, id = "method-toggle" }) => {
    return (
        <div className={styles.methodToggle} id={id}>
            {options.map((option, index) => (
                <button
                    key={option.value}
                    id={`${id}-button-${index}`}
                    type="button"
                    className={`${styles.toggleButton} ${selectedValue === option.value ? styles.isActive : ''}`}
                    onClick={() => onChange(option.value)}
                    aria-keyshortcuts={option.ariaKeyshortcuts || undefined}
                    title={option.shortcutTooltip || undefined}
                >
                    {option.label}
                    {option.shortcutHint && (
                        <span className={styles.shortcutHint} id={`${id}-button-${index}-shortcut-hint`}>
                            {option.shortcutHint}
                        </span>
                    )}
                </button>
            ))}
        </div>
    );
};

export default MethodToggle;
